module.exports = __webpack_public_path__ + "img/countries.e9f9d465.png";